"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonCard = void 0;
const ProjectCard_1 = require("../ProjectCard");
class MoonCard extends ProjectCard_1.ProjectCard {
    constructor(properties, moonCardProperties = {}) {
        super(properties);
        this.moonCardProperties = moonCardProperties;
    }
    get tilesBuilt() {
        return this.moonCardProperties.tilesBuilt || [];
    }
    canPlay(player) {
        return super.canPlay(player) && player.canAdjustProduction(this.productionBox);
    }
    play(player) {
        super.play(player);
        player.adjustProduction(this.productionBox, { log: true });
        return undefined;
    }
}
exports.MoonCard = MoonCard;
//# sourceMappingURL=MoonCard.js.map